import React from 'react';
import { number, object, string, arrayOf, func, bool, oneOfType } from 'prop-types';
import ToolbarSection from '../toolbar/';
import ListingItemsSection from '../items/';

export default function ListingItemsLayout(props) {
    return (
        <div className="listing-layout">
            <ToolbarSection
                showResultCount={props.showResultCount}
                itemCount={props.itemCount}
                sortBy={props.sortBy}
                currentSort={props.currentSort}
                updateSort={props.updateSort}
            />
            <ListingItemsSection
                listingItems={props.listingItems}
                resources={props.resources}
                itemWrapperModifier={props.itemWrapperModifier}
                itemDirection={props.itemDirection}
                itemType={props.itemType}
                listingIntro={props.listingIntro}
                totalPages={props.totalPages}
                currentPage={props.currentPage}
                changePage={props.changePage}
                resetFilters={props.resetFilters}
            />
        </div>
    );
}

ListingItemsLayout.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    listingItems: arrayOf(object).isRequired,
    itemCount: number.isRequired,
    itemWrapperModifier: string.isRequired,
    itemType: string.isRequired,
    listingIntro: string.isRequired,
    itemDirection: string.isRequired,
    sortBy: arrayOf(object),
    currentSort: oneOfType([string, object]),
    updateSort: func.isRequired,
    showResultCount: bool,
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    resources: arrayOf(object),
    resetFilters: func.isRequired,
    changePage: func.isRequired
    /* eslint-enable react/no-typos */
};

ListingItemsLayout.defaultProps = {
    sortBy: [],
    currentSort: '',
    showResultCount: false,
    resources: []
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/layouts/ListingItemsLayout.jsx